// ---- currency / number formatting ----
export const SYMBOLS = {
  GBP: "£",
  USD: "$",
  EUR: "€",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF ",
  DKK: "kr ",
  JPY: "¥",
};
// Negative amounts render as "-£938.54" (sign BEFORE the currency
// glyph), not "£-938.54", so discount rows and sandbox-driven cost
// reductions read naturally. JPY has no minor units, so callers pass
// decimals=0 and yen render as "¥12,345".
export const fmtMoney = (n, sym = "£", decimals = 2) => {
  const v = Number(n || 0);
  const abs = Math.abs(v).toLocaleString("en-GB", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${v < 0 ? "-" : ""}${sym}${abs}`;
};
export const fmtDate = (iso) => {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

// ---- proposal validity ----
// Per Medicys' T&Cs (§ "Validity of Quotation") every quote is valid
// for 90 days from the proposal date. After that the figures need
// re-issuing because supplier rates, FX and feasibility may have
// shifted. We surface this as an active chip pre-expiry and a dimmed
// banner once the window closes. The number `90` lives in T&Cs and
// should change here in lock-step.
export const QUOTE_VALIDITY_DAYS = 90;

export const computeQuoteValidity = (proposalDateISO) => {
  if (!proposalDateISO) return null;
  const start = new Date(proposalDateISO);
  if (Number.isNaN(start.getTime())) return null;
  const validUntil = new Date(start);
  validUntil.setDate(validUntil.getDate() + QUOTE_VALIDITY_DAYS);
  // Compare on calendar-day boundaries (ignore time-of-day) so the
  // countdown ticks at midnight, not at the proposal's hour.
  const today = new Date();
  const startOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const startOfExpiry = new Date(
    validUntil.getFullYear(),
    validUntil.getMonth(),
    validUntil.getDate()
  );
  const msPerDay = 86400000;
  const daysRemaining = Math.round((startOfExpiry - startOfToday) / msPerDay);
  return {
    validUntil,
    daysRemaining,
    expired: daysRemaining < 0,
    expiresToday: daysRemaining === 0,
  };
};
